import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import branch from 'branch-sdk';
import { useDispatch, useSelector } from 'react-redux';
import { Endpoints } from "../../Global/Endpoints";
import axios from 'axios';

const BranchListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector((state) => state.userData);
  const token = localStorage.getItem('AccessToken');
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);

  useEffect(() => {
    console.log('[BranchListener] Initializing Branch deep link listener NEW');

    branch.init('key_live_aFhXqy0CNUR22lnOcqB2RpgiEzbdVs9x', async (err, data) => {
      if (err) {
        console.error('[BranchListener] Branch init error', err);
        if (location.pathname === '/session-expired') {
          console.log('[BranchListener] User on session-expired page, skipping error redirect');
          return;
        }
        return;
      }

      console.log('[BranchListener] Branch init success', data);
      console.log('[BranchListener] isAuthenticated:', isAuthenticated);

      if (isAuthenticated) {

         // ✅ Inject mock data ONLY during local development
    // if (data.data=="" ) {
    //     console.warn('[BranchListener] No data received from Branch. Using mock data for local testing.');
  
    //     data = {
    //         data: "{\"+match_guaranteed\":true,\"~creation_source\":0,\"+clicked_branch_link\":true,\"+click_timestamp\":1747906519,\"~id\":1443921987943807980,\"~referring_browser\":\"Chrome\",\"+is_first_session\":false,\"campaign\":\"winfertility-companion\",\"custom_meta_tags\":\"{\\\"MemberID\\\":\\\"40055545_20\\\",\\\"AppUserID\\\":\\\"Greystar-Reimbursement Program\\\",\\\"PageName\\\":\\\"Wincentive\\\"}\",\"~referring_link\":\"https://winfertility.app.link/qIQZbuclPSb?__branch_flow_id=1454032208830784017&~referring_browser=Chrome\"}",
    //       data_parsed: {
    //         "+match_guaranteed": true,
    //         "~creation_source": 0,
    //         "+clicked_branch_link": true,
    //         "+click_timestamp": 1747906519,
    //         "~id": 1443921987943808000,
    //         "~referring_browser": "Chrome",
    //         "+is_first_session": false,
    //         "campaign": "winfertility-companion",
    //         "custom_meta_tags": JSON.stringify({
    //           MemberID: "40055545_20",
    //           AppUserID: "Greystar-Reimbursement Program",
    //           PageName: "PhoneVideoConsult"
    //         }),
    //         "~referring_link": "https://winfertility.app.link/qIQZbuclPSb?__branch_flow_id=1454032208830784017&~referring_browser=Chrome"
    //       }
    //     };
    //   }
 // ✅ Inject mock data schedule appointment ONLY during local development
//  debugger;
  // if (data.data=="" ) {
  //       console.warn('[BranchListener] No data received from Branch. Using mock data for local testing.');
      
  //        data = {
  //   "data": "{\"+match_guaranteed\":true,\"$marketing_title\":\"test_andropause\",\"~creation_source\":1,\"$link_title\":\"test_andropause\",\"~marketing\":true,\"+clicked_branch_link\":true,\"+click_timestamp\":1761199638,\"~referring_browser\":\"Chrome\",\"~id\":1507632913146228885,\"+is_first_session\":false,\"custom_meta_tags\":\"{\\\"PageName\\\": \\\"SelectDateConsult\\\", \\\"SlotType\\\":\\\"Andropause-Phone\\\"}\",\"~referring_link\":\"https://winfertility.app.link/Liyai3A8wXb?__branch_flow_id=1509787590073980759&~referring_browser=Chrome\"}",
  //   "data_parsed": {
  //       "+match_guaranteed": true,
  //       "$marketing_title": "test_andropause",
  //       "~creation_source": 1,
  //       "$link_title": "test_andropause",
  //       "~marketing": true,
  //       "+clicked_branch_link": true,
  //       "+click_timestamp": 1761199638,
  //       "~referring_browser": "Chrome",
  //       "~id": 1507632913146229000,
  //       "+is_first_session": false,
  //       "custom_meta_tags": JSON.stringify({
  //         PageName: "CaregiverSupport",
  //        // SlotType: "Andropause-Phone"
  //            SupportCardType: "Caregiver Support"
  //       }),
  //       "~referring_link": "https://winfertility.app.link/Liyai3A8wXb?__branch_flow_id=1509787590073980759&~referring_browser=Chrome"
  //         }
  //       };
  //      }
       

      console.log('[BranchListener] Branch init success after Authenticated', data);
        console.log('[BranchListener] Branch init success after Authenticated', data);

        if (data.data && data.data_parsed) {
          let screen = data.data_parsed.screen;
          let supportCardType = data.data_parsed.supportCardType;

          // 1. Parse custom_meta_tags if screen is missing
          if (!screen && typeof data.data_parsed.custom_meta_tags === 'string') {
            try {
              const meta = JSON.parse(data.data_parsed.custom_meta_tags);
              console.log('[BranchListener] Parsed custom_meta_tags:', meta);

              if (meta.PageName) {
                screen = meta.PageName.trim();
                supportCardType = meta.SupportCardType;
                console.log(`[BranchListener] Using PageName from custom_meta_tags as screen: ${screen}`);
              }
            } catch (e) {
              console.warn('[BranchListener] Failed to parse custom_meta_tags:', e);
            }
          }

          // 2. Normalize and navigate
          if (screen && typeof screen === 'string') {
            const normalizedScreen = screen.charAt(0).toUpperCase() + screen.slice(1);
            console.log(`[BranchListener] Navigating to screen: ${normalizedScreen}`);

            if (normalizedScreen === "SelectDateConsult" && typeof data.data_parsed.custom_meta_tags === 'string') {
              try {
                const meta = JSON.parse(data.data_parsed.custom_meta_tags);
                const SlotType = meta.SlotType;
                console.log(`[BranchListener] Extracted SlotType: ${SlotType}`);

                let selectedType = SlotType;
                if (SlotType && SlotType.includes('-')) {
                  selectedType = SlotType.split('-')[0];
                  console.log(`[BranchListener] Derived selectedType: ${selectedType} from SlotType: ${SlotType}`);
                }

                navigate('/calendar-view', { state: { SlotType, selectedType } });
                return;
              } catch (e) {
                console.warn('[BranchListener] Failed to parse custom_meta_tags for SelectDateConsult:', e);
              }
            }

            console.log(`[BranchListener] Navigating to screen: ${normalizedScreen}`);
            navigateToScreen(normalizedScreen, supportCardType, navigate, isAuthenticated);
          } else {
            console.warn('[BranchListener] No valid screen found. Redirecting to /home');
            if (location.pathname === '/session-expired') {
              console.log('[BranchListener] User on session-expired page, skipping home redirect');
              return;
            }
            navigate('/home');
          }
        }
      } else {
        // Don't redirect if user is on session-expired page
        if (location.pathname === '/session-expired') {
          console.log('[BranchListener] User on session-expired page, skipping redirect');
          return;
        }
    //     if (data.data=="" ) {
    //     console.warn('[BranchListener] No data received from Branch. Using mock data for local testing.');
  
    //      data = {
    //           "data": "{\"+match_guaranteed\":true,\"$marketing_title\":\"test_andropause\",\"~creation_source\":1,\"$link_title\":\"test_andropause\",\"~marketing\":true,\"+clicked_branch_link\":true,\"+click_timestamp\":1761199638,\"~referring_browser\":\"Chrome\",\"~id\":1507632913146228885,\"+is_first_session\":false,\"custom_meta_tags\":\"{\\\"PageName\\\": \\\"SelectDateConsult\\\", \\\"SlotType\\\":\\\"Andropause-Phone\\\"}\",\"~referring_link\":\"https://winfertility.app.link/Liyai3A8wXb?__branch_flow_id=1509787590073980759&~referring_browser=Chrome\"}",        "~marketing": true,
    // "data_parsed": {
    //     "+match_guaranteed": true,
    //     "$marketing_title": "test_andropause",
    //     "~creation_source": 1,
    //     "$link_title": "test_andropause",
    //     "+click_timestamp": 1761199638,
    //     "~referring_browser": "Chrome",
    //     "~id": 1507632913146229000,
    //     "+is_first_session": false,
    //     "custom_meta_tags": JSON.stringify({
    //       PageName: "ChildDevelopment",
    //      // SlotType: "Andropause-Phone"
    //          SupportCardType: "Child Development"
    //     }),
    //     "~referring_link": "https://winfertility.app.link/Liyai3A8wXb?__branch_flow_id=1509787590073980759&~referring_browser=Chrome"
    //       }
    //     };
    //    }
        if (data.data && data.data_parsed) {
          let screen = data.data_parsed.screen;
          let supportCardType = data.data_parsed.supportCardType;

          // 1. Parse custom_meta_tags if screen is missing
          if (!screen && typeof data.data_parsed.custom_meta_tags === 'string') {
            try {
              const meta = JSON.parse(data.data_parsed.custom_meta_tags);
              console.log('[BranchListener] Parsed custom_meta_tags:', meta);
              if (meta.PageName) {
                screen = meta.PageName.trim();
                supportCardType = meta.SupportCardType;
                console.log(`[BranchListener] Using PageName from custom_meta_tags as screen: ${screen}`);
                const normalizedScreen = screen.charAt(0).toUpperCase() + screen.slice(1);
                navigateToScreen(normalizedScreen, supportCardType, navigate, isAuthenticated);
              }
            } catch (e) {
              console.warn('[BranchListener] Failed to parse custom_meta_tags:', e);
              navigate('/login');
            }
          }
        }
      }
    });
  }, [location, navigate, isAuthenticated]);

  return null;
};

// Remove useSelector from here and pass it down
const navigateToScreen = (screen, supportCardType, navigate, isAuthenticated) => {
  const routeMap = {
    Login: '/login',
    ForgotPassword: '/forgotpassword',
    ResetPassword: '/resetpassword',
    NotificationPreferences: '/notification-preference',
    UpdatePhoneNumber: '/updatephonenumber',
    UpdateProfileInformation: '/edit-UpdateProfileInformation',
    InsuranceCardUpload: '/insurenceupload',
    PrivacyPolicy: '/PrivacyPolicy',
    TermsAndConditions: '/TermsAndConditions',
    Me: '/edit-healthprofilesetup',
    Benefits: '/benefit-options',
    BenefitDetails: '/benefit-details',
    BenefitAccumulator: '/benefits-accumulator',
    TreatmentAuthorizations: '/treatment-authorization',
    TreatmentCostEstimatier: '/benefits-treatmentcostestimator',
    MyDocuments: '/benefits-mydocuments',
    RXAuthorizations: '/benefits-rxauthorization',
    PHIForm: '/benefits-phiform',
    PatientID: '/benefit-patientid',
    FindCare: '/find-care',
    BookAnAppointment: '/book-appointment',
    FindAProvider: '/load-findcare-list',
    PhoneVideoConsult: '/book-appointment',
    SelectDateConsult: '/calendar-view',
    ReproductiveEndocrinologists: '/load-findcare-list',
    Doulas: '/doulas',
    Chat: '/chat-bot',
    Notifications: '/notifications',
    UpcomingAppointments: '/appointment-cancellation-reschedule',
    Education: '/continuereading',
    PregnancySymptomTracker: '/pregnancy',
    WeeklyPregnancyTracker: '/weekly-pregnancy-tracker',
    Webinars: '/play-video',
    Wincentive: '/incentive-landingpage',
    RewardHistory: '/incentive-rewardshistory',
    Achievements: '/incentive-achievementdetails',
    MyWinCard: '/pay-cards',
    WinPay: '/pay-landingpage',
    Home: '/home',
    Support: '/support-services',
    MyWINCards: '/pay-cards',
    RequestnewWINCard: '/pay-cards',
    UploadSupportingDocument: '/pay-supportservicedocument',
    RequestReimbursement: '/pay-reimbursement',
    MyBenefitWINCard: '/pay-cards',
    MyWINCentiveWINCard: '/pay-cards',
    Treatment: '/feedServices',
    RequestNewAuthorization: '/verbal-authorization',
    BIPOC: '/support-services',
    Maternity: '/maternity-assessment',
    Fertility: '/fertility',
    Preconception: '/prepregnancydetails',
    BehaviouralHealth: '/bhassessment',
    Nutrition: '/support-services',
    ChildDevelopment: '/support-services',
    CaregiverSupport: '/support-services',
    MensHealth: '/support-services',
    Surrogacy: '/support-services',
    WomensHealth: '/support-services',
    Adoption: '/support-services',
    Prescriptions: '/rx-authorization',
    FertilityTracker: '/fertility',
    MenopauseTracker: '/menopause',
    AndropauseTracker: '/andropause',
    ShareMyStory: '/incentive-story',
    PregnancyAssessment: '/maternity-assessment',
    BHAssessment: '/bhassessment',
  };

  console.log("navigateToscreen, screen : ", screen, "routeMap[screen] : ", routeMap[screen])
  if (routeMap[screen]) {
    console.log(`[BranchListener] Found route for screen: ${screen}, navigating to: ${routeMap[screen]}`);
    if (routeMap[screen] === "/support-services") {
      console.log("Support services 1")
      const updatedLink = {
          originalText: supportCardType || "",
          displayText: supportCardType || "",
          isBranchIORedirection: true,
        };
      if (isAuthenticated) {
        
        // navigate(routeMap[screen],  {state: updatedLink, replace: true })
        navigate("/home", { state : { subRedirection: routeMap[screen], updatedLink: updatedLink}});
        // navigate(routeMap[screen], { state: updatedLink });
      } else {
        console.log("Support services 2")
        navigate('/login', { state: { subRedirection: routeMap[screen], updatedLink: updatedLink } });
      }
    } else {
            console.log("Support services 3")

      navigate(routeMap[screen]);
    }
  } else {
    console.log(`[BranchListener] No route found for screen: ${screen}, navigating to default /home`);
    navigate('/home');
  }
};

export default BranchListener;
